/* eslint-disable no-console */
export const log = (...args: any[]) => {
    if (!["PRODUCTION", "PROD", "production", "prod", "prd"].includes(process.env.ENVIRONMENT ?? '')) {
        console.warn('[auth-core]', ...args);
    }
};
